import angular from 'angular';
import documentAccordion from './documentAccordion';
import './style.scss';

export default angular
  .module('scenes.documentAccordion', [])
  .component('documentAccordion', documentAccordion).name;
